/**
 * 外部ウィンドウを開く
 * @param {Object} url
 * @param {Object} options
 */
function openWindow(url, options) {
  let setting = {
    // TODO ウィンドウ名は乱数で払いだすこと。
    name: 'newWindow',
    width: 800,
    height: 600,
  };
  // オプションをマージする
  if (options) {
    setting = jQuery.extend(setting, options);
  }

  const window_options = `width=${setting.width}, height=${setting.height}, menubar=no, toolbar=no, scrollbars=yes, resizable=yes`;

  const nWindow = window.open(url, setting.name, window_options);
  nWindow.focus();
}

export default openWindow;



// WEBPACK FOOTER //
// ./es6/admin-common-js/utils/openWindowUtils.js